import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api, { CHAVE_TOKEN } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);

  // Reidrata a sessão no F5: o token está no localStorage, mas quem manda é o
  // servidor — permissão revogada tem efeito no próximo request, não "quando o
  // token expirar".
  useEffect(() => {
    const token = localStorage.getItem(CHAVE_TOKEN);
    if (!token) { setCarregando(false); return; }
    api.get('/api/auth/me')
      .then((r) => setUsuario(r.data))
      .catch(() => localStorage.removeItem(CHAVE_TOKEN))
      .finally(() => setCarregando(false));
  }, []);

  const login = useCallback(async (username, senha) => {
    const { data } = await api.post('/api/auth/login', { username, senha });
    localStorage.setItem(CHAVE_TOKEN, data.token);
    setUsuario(data.usuario);
    return data.usuario;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(CHAVE_TOKEN);
    setUsuario(null);
    window.location.href = '/login';
  }, []);

  // Autorização é sempre por permissão nomeada, nunca por perfil.
  const temPermissao = useCallback(
    (...nomes) => !!usuario && nomes.some((n) => usuario.permissoes?.includes(n)),
    [usuario]
  );

  return (
    <AuthContext.Provider value={{ usuario, carregando, login, logout, temPermissao }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
